import axios from 'axios'

export default {
  getTripInfo(params) {
    return axios.get(`/trip/${params.identity}`)
  },
  getGoogleInfo(params) {
    return axios.get(`/google/${params.identity}`)
  }
}
